<template>
  <v-dialog v-model="dialog" width="1200px">
    <v-card>
      <v-card-title class="mx-3">
        {{ $t("AlliancesShops.shopList", [(alliance ? alliance.alliance_business_name : ''), $consts.shopName()]) }}
        <v-spacer />
        <v-tooltip left>
          <template v-slot:activator="{ on, attrs }">
            <v-icon v-bind="attrs" v-on="on" @click="dialog = false">
              fa-times
            </v-icon>
          </template>
          <span>{{ $t("$vuetify.close") }}</span>
        </v-tooltip>
      </v-card-title>
      <v-data-table
        :headers="headers"
        :items="shops"
        :loading="loading"
        multi-sort
        class="elevation-0 px-6"
        v-resize="resizeHeader"
        height="340px"
        :footer-props="footerProps"
      >
      </v-data-table>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="primary"
          outlined
          class="elevation-1"
          @click="dialog = false"
        >
          {{ $t("$vuetify.close") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState } from "vuex";
import i18n from "@/i18n";
import AllianceBusinessShops from "@/api/alliance_business_shops"

export default {
  name: "ShopDialog",

  props: {
    value: Boolean,
    alliance: Object,
  },

  components: {
  },

  computed: {
    headers() {
      return [
        {
          text: i18n.t("Shop.Fields.shop_code", [this.$consts.shopName()]),
          align: "start",
          sortable: true,
          class: "text-no-wrap",
          value: "shop_code",
        },
        {
          text: i18n.t("Shop.Fields.shop_name", [this.$consts.shopName()]),
          align: "start",
          sortable: true,
          class: "text-no-wrap",
          value: "shop_name",
        },
        {
          text: i18n.t("Shop.Fields.shop_district"),
          align: "start",
          sortable: false,
          class: "text-no-wrap",
          value: "district.name",
        },
        {
          text: i18n.t("Shop.Fields.shop_user_name"),
          align: "center",
          sortable: false,
          class: "text-no-wrap",
          value: "shop_user.name",
        },
        {
          text: i18n.t("Shop.Fields.template"),
          align: "start",
          sortable: false,
          class: "text-no-wrap",
          value: "template_name",
        },
        {
          text: i18n.t("Shop.Fields.login_user_id"),
          align: "start",
          sortable: false,
          class: "text-no-wrap",
          value: "shop_user.login_user_id",
        },
      ];
    },
    footerProps() {
      return Object.assign({}, i18n.t("$config.footer-props"), {
        itemsPerPageOptions: [this.itemsPerPageOptions],
      });
    },
    // 使用对象展开运算符将此对象混入到外部对象中
    ...mapState(["loading", "settings"]),
  },

  data: () => ({
    dialog: false,
    shops: [],
    itemsPerPageOptions: 10,
  }),

  methods: {
    resizeHeader() {
      this.itemsPerPageOptions = window.innerHeight > 800 ? 10 : 5;
    },
    //获取shop列表
    getShopsFromAPI() {
      let options = {
        limit: this.$consts.limitAll
      };
      AllianceBusinessShops.fetchSelectShops(this.alliance.id, options).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.shops = response.data.alliance_business_shops.map(allianceBusinessShop=>{
              return allianceBusinessShop.shop
            })
          }
        }.bind(this)
      );
    },
  },

  watch: {
    value: {
      immediate: true, //初始赋值也调用
      handler() {
        if (this.value) {
          this.dialog = this.value;
          this.getShopsFromAPI();
        }else {
          this.shops = []
        }
      },
    },
    dialog: {
      handler() {
        this.$emit("input", this.dialog);
      },
    },
  },
};
</script>